var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-8 offset-md-2" }, [
              _vm.showMsg
                ? _c(
                    "div",
                    {
                      staticClass:
                        "alert alert-danger alert-dismissible fade show",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(_vm.msg) + "\n            "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "alert",
                            "aria-label": "Fechar"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.hideMsg()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMsgSuccess
                ? _c(
                    "div",
                    {
                      staticClass:
                        "alert alert-success alert-dismissible fade show",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.msgSuccess) +
                          "\n            "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "alert",
                            "aria-label": "Fechar"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.hideMsg()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "form",
                { staticClass: "preference-form" },
                [
                  _c(
                    "carousel",
                    {
                      ref: "firstaccess-carousel",
                      staticClass: "carousel",
                      attrs: {
                        autoplay: false,
                        perPage: 1,
                        paginationEnabled: false
                      }
                    },
                    [
                      _c(
                        "slide",
                        { staticClass: "slide" },
                        [
                          _vm.fullname
                            ? _c("h1", [
                                _vm._v(
                                  "Olá " +
                                    _vm._s(_vm.fullname) +
                                    ", bem-vindo(a) à Click2giv!"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v(
                              "Antes de começarmos, gostariamos de saber: Quais são os tipos de projetos sociais que tocam o seu coração?\n                  (Escolha pelo menos uma opção abaixo)"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "b-form-checkbox-group",
                                {
                                  attrs: {
                                    id: "checkbox-group-1",
                                    name: "flavour-2",
                                    stacked: ""
                                  },
                                  model: {
                                    value: _vm.selectedCategories,
                                    callback: function($$v) {
                                      _vm.selectedCategories = $$v
                                    },
                                    expression: "selectedCategories"
                                  }
                                },
                                _vm._l(_vm.arrCategoriesWithMessages, function(
                                  c,
                                  k
                                ) {
                                  return _c(
                                    "b-form-checkbox",
                                    {
                                      key: k,
                                      attrs: {
                                        size: "lg",
                                        value: c.categories
                                      },
                                      model: {
                                        value: _vm.selectedCategories,
                                        callback: function($$v) {
                                          _vm.selectedCategories = $$v
                                        },
                                        expression: "selectedCategories"
                                      }
                                    },
                                    [_vm._v(_vm._s(c.message))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.nextSlide()
                                }
                              }
                            },
                            [_vm._v("Próximo")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "slide",
                        { staticClass: "slide" },
                        [
                          _vm.fullname
                            ? _c("h1", [
                                _vm._v(
                                  "Olá " +
                                    _vm._s(_vm.fullname) +
                                    ", bem-vindo(a) à Click2giv!"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v(
                              "\n                  Você pode contribuir com uma Organização Social através de algum conhecimento que você tenha,\n                  alguma habilidade, especialização, e assim ajudar a transformar a vida de milhares de pessoas. "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                  Escolha na lista abaixo as habilidades que você possui e que gostaria de disponibilizar para uma Organização Social.\n                  Identificaremos uma ONG que necessita deste apoio e colocaremos vocês em contato.\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "b-form-radio-group",
                                {
                                  attrs: {
                                    id: "checkbox-group-2",
                                    name: "flavour-2",
                                    stacked: ""
                                  },
                                  model: {
                                    value: _vm.selectedHability,
                                    callback: function($$v) {
                                      _vm.selectedHability = $$v
                                    },
                                    expression: "selectedHability"
                                  }
                                },
                                _vm._l(_vm.arrHabilitiesWithMessages, function(
                                  c,
                                  k
                                ) {
                                  return _c(
                                    "b-form-radio",
                                    {
                                      key: k,
                                      attrs: { size: "lg", value: c.hability }
                                    },
                                    [_vm._v(_vm._s(c.message))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.lastSlide()
                                }
                              }
                            },
                            [_vm._v("Próximo")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "slide",
                        { staticClass: "slide" },
                        [
                          _c("h4", [
                            _vm._v(
                              "Também gostariamos de saber: quais tipos de loja mais lhe agradam?\n                  (Escolha pelo menos uma opção abaixo)"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "b-form-checkbox-group",
                                {
                                  attrs: {
                                    id: "checkbox-group-3",
                                    name: "flavour-2",
                                    stacked: ""
                                  },
                                  model: {
                                    value: _vm.selectedStoreCategories,
                                    callback: function($$v) {
                                      _vm.selectedStoreCategories = $$v
                                    },
                                    expression: "selectedStoreCategories"
                                  }
                                },
                                _vm._l(_vm.storeCategories, function(c) {
                                  return _c(
                                    "b-form-checkbox",
                                    {
                                      key: c.categoryId,
                                      attrs: {
                                        size: "lg",
                                        value: c.categoryId
                                      },
                                      model: {
                                        value: _vm.selectedStoreCategories,
                                        callback: function($$v) {
                                          _vm.selectedStoreCategories = $$v
                                        },
                                        expression: "selectedStoreCategories"
                                      }
                                    },
                                    [_vm._v(_vm._s(c.categoryName))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.register()
                                }
                              }
                            },
                            [_vm._v("Salvar Preferências")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8daa9798", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8daa9798","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FirstAccess.vue
// module id = null
// module chunks = 